// components/weather/WeatherHeader.jsx
import React from 'react';

const WeatherHeader = ({ currentAddress, forecast, isLoading }) => {
    return (
        <>
            <h4 className="weather-header-address">{currentAddress}</h4>
            <h2 className="weather-header-forecast">
                {isLoading ? '날씨 정보 로딩 중...' : forecast}
            </h2>
        </>
    );
};

export default WeatherHeader;